import type { ConsoleRoute } from '../index';
import { ReviewQueuePage } from '../engagement/ReviewQueuePage';
import { EntriesPage } from './EntriesPage';
import { ParticipantPage } from './ParticipantPage';

/** Entries + engagement consoles (docs/modules/entries.md, docs/modules/engagement.md). */
export const entriesRoutes: ConsoleRoute[] = [
  {
    path: 'lotteries/:id/entries',
    handle: { permission: 'lottery.read', title: 'Entries' },
    element: <EntriesPage />,
  },
  {
    path: 'participants/:id',
    handle: { permission: 'lottery.read', title: 'Participant' },
    element: <ParticipantPage />,
  },
  {
    path: 'engagement',
    handle: { permission: 'engagement_tasks.manage', title: 'Engagement review' },
    element: <ReviewQueuePage />,
  },
];
